import React, { createContext, useState } from 'react';

export const MailRoomContext = createContext();

const MailRoomProvider = ({ children }) => {
  const [searchValue, setSearchValue] = useState('');
  const [searchByDocName, setSearchByDocName] = useState(undefined);
  const [selectedTags, setSelectedTags] = useState([]);
  const [payloadTags, setPayloadTags] = useState({});
  const [startAndEndDate, setStartAndEndDate] = useState({});
  const [pageFilter, setPageFilter] = useState('');
  const [docsCount, setDocsCount] = useState(0);
  const [pagesCount, setPagesCount] = useState(0);

  const clearAllFilters = () => {
    setSearchValue('');
    setSearchByDocName(undefined);
    setSelectedTags([]);
    setPayloadTags([]);
    setStartAndEndDate({});
    setPageFilter('');
    setDocsCount(0);
    setPagesCount(0);
  };

  return (
    <MailRoomContext.Provider
      value={{
        searchValue,
        setSearchValue,
        searchByDocName,
        setSearchByDocName,
        selectedTags,
        setSelectedTags,
        payloadTags,
        setPayloadTags,
        startAndEndDate,
        setStartAndEndDate,
        docsCount,
        setDocsCount,
        pagesCount,
        setPagesCount,
        pageFilter,
        setPageFilter,
        clearAllFilters,
      }}
    >
      {children}
    </MailRoomContext.Provider>
  );
};

export default MailRoomProvider;
